<template lang="pug">
  div
    form.w-full.max-w-2xl.mt-6(v-on:submit="sendRequest")
      .flex.flex-wrap.-mx-3
        .w-full.px-3(class='md:w-3/6 md:mb-0')
          label(for='hostname') Hostname
          input#hostname(placeholder='k.io' type="text" v-model="hostname")
        .w-full.px-3(class='md:w-1/6 md:mb-0')
          label(for='type') Record Type
          CustomSelect(:options="record_types" v-model="type" id="type")
        .w-full.px-3(class='md:w-2/6 md:mb-0')
          label(for='trace') Trace
          CustomSelect(:options="[['Full Trace', true], ['Krystal DNS Cache', false]]" v-model="trace" id="trace")
      input.button.mt-3(type="submit" v-bind:disabled="loading" v-bind:class="{ 'opacity-50': loading }" value="Send")
    div.text-gray-100.font-mono.bg-black.rounded.p-4.mt-6(v-if="response || hasError")
      div.text-red-400(v-if="hasError") {{errorMessage}}
      div(v-else v-for="result in response")
        div.text-gray-500 {{result.server}}
        div.ml-4(v-for="answer in result.answers") {{answer.type}}: {{answer.name}}, {{answer.value}} (TTL: {{answer.ttl}})
</template>
<script>
import CustomSelect from "@/components/CustomSelect";
import common_computed from "@/mixins/common_computed";
import errors from "@/mixins/errors";

export default {
  mixins: [common_computed, errors],
  components: {
    CustomSelect: CustomSelect,
  },
  data() {
    return {
      hostname: "",
      type: "A",
      trace: true,
      response: null,
      record_types: [
        ["A", "A"],
        ["AAAA", "AAAA"],
        ["NS", "NS"],
        ["MX", "MX"],
        ["SOA", "SOA"],
        ["TXT", "TXT"],
      ],
    };
  },
  computed: {
    searchParams() {
      return new URLSearchParams({
        hostname: this.hostname,
        type: this.type,
        trace: this.trace,
      });
    },
  },
  methods: {
    sendRequest(e) {
      e.preventDefault();
      this.clearError();
      this.response = null;
      this.loading = true;
      fetch(`${this.selectedHost}/v1/dns/lookup?${this.searchParams}`, {
        method: "GET",
      })
        .then((resp) => {
          this.loading = false;
          if (!resp.ok) {
            this.hasError = true;
          }
          return resp.json();
        })
        .then((json) => {
          if (this.hasError) {
            this.setError(json.error.description);
          } else {
            this.response = json.results;
          }
        })
        .catch((error) => {
          console.error(error);
          this.setError("Unable to lookup DNS, an error occurred");
        });
    },
  },
};
</script>
